export const enCommon = {
    common: {
        asset: 'Asset',
        assets: 'Assets',
        allAssets: 'All assets',
        assetImageAlt: 'Asset image',
        structure: 'Structure',
        structures: 'Structures',
        customer: 'Customer',
        customers: 'Customers',
        mandator: 'Mandator',
        mandators: 'Mandators',
        order: 'Order',
        orders: 'Orders',
        valuation: 'Valuation',
        valuations: 'Valuations',
        valuationReport: 'Valuation report',
        valXml: 'ValXML',
        valueCheck: 'Value check',
        draft: 'Draft',
        drafts: 'Drafts',
        final: 'Final',
        imported: 'Imported',
        review: 'Review',
        approved: 'Approved',
        latestDraft: 'Latest draft',
        latestValuation: 'Latest valuation',
        latestOrder: 'Latest order',
        overview: 'Overview',
        keyFigures: 'Key figures',
        valuationHistory: 'Valuation history',
        deviationAnalysis: 'Deviation analysis',
        location: 'Location',
        prices: 'Prices',
        dcf: 'DCF',
        tenantList: 'Tenant list',
        marketData: 'Market data',
        report: 'Report',
        reportTypes: {
            shortReport: {
                title: 'Market & mortgage lending value',
                description: 'pursuant to § 16 PfandBG',
            },
            extendedReport: {
                title: 'Market value',
                description: 'pursuant to § 194 BauGB',
            },
            revaluationReport: {
                title: 'Revaluation',
                description: 'pursuant to § 194 BauGB',
            },
            benchmarkReport: {
                title: 'Value indication',
            },
        },
        allReports: 'All reports',
        allValXmls: 'All ValXMLs',
        unknown: 'Unknown',
        unlimited: 'Unlimited',
        noDate: 'No date',
        orderDate: 'Order date',
        valuationDate: 'Valuation date',
        marketValue: 'Market value',
        landValue: 'Land value',
        grossRentalIncome: 'Gross rental income',
        contractRent: 'Contract rent',
        task: 'Task',
        tasks: 'Tasks',
        document: 'Document',
        documents: 'Documents',
        message: 'Conversation',
        messages: 'Conversations',
        thread: 'Conversation',
        threads: 'Conversations',
        appraiser: 'Appraiser',
        appraisers: 'Appraisers',
        image: 'Image',
        images: 'Images',
        portfolio: 'Portfolio',
        portfolios: 'Portfolios',
        notification: 'Notification',
        profile: 'Profile',
        logout: 'Sign out',
        tools: 'Tools',
        analysis: 'Analysis',
        plausibility: 'Plausibility check',
        leadingMethod: 'Leading method',
        leadingMethods: 'Leading methods',
        usedMethod: 'Used method',
        usedMethods: 'Used methods',
        valueTrend: 'Value development',
        rentalIncome: 'Contract rent',
        grossCapitalValue: 'Gross capital value',
        netCapitalValue: 'Net capital value',
        netYield: 'Net yield',
        ancillaryAcquisitionCosts: 'Ancillary acquisition costs',
        managementCosts: 'Management costs',
        marketRent: 'Market rent',
        absolute: 'Absolute',
        relative: 'Relative',
        rent: 'Rent',
        usageType: 'Usage type',
        subUsageType: 'Sub-usage type',
        date: 'Date',
        year: 'Year',
        years: 'Years',
        index: 'Index',
        count: 'Count',
        share: 'Share',
        remaining: 'Other',
        units: 'Units',
        parkingSpaces: 'Parking spaces',
        vacancyRate: 'Vacancy rate',
        actualConstructionYear: 'Actual year of construction',
        economicConstructionYear: 'Economic year of construction',
        valuationYear: 'Valuation year',
        usefulLife: 'Useful life',
        totalEconomicLifeSpan: 'Total economic life',
        calculatedResidualLifeSpan: 'Calculated residual useful life',
        customResidualLifeSpan: 'Economic residual useful life',
        customResidualLifeSpanOverride: 'Economic residual useful life (overridden)',
        grossInitialYield: 'Gross initial yield',
        grossYield: 'Gross yield',
        grossYieldVerbose: 'Yield (gross yield)',
        discountRate: 'Discount rate',
        rentableArea: 'Rentable area',
        livingArea: 'Living area',
        usageArea: 'Usable area',
        grossFloorArea: 'Gross floor area',
        landArea: 'Land area',
        wault: 'WAULT',
        valuePerSquareMeter: 'Value per m²',
        valuePerSquareMeterRentableArea: 'Value per m² rentable area',
        valuePerSquareMeterGfa: 'Value per m² GFA',
        valuePerSquareMeterLand: 'Value per m² land',
        mortgageLendingValue: 'Mortgage lending value',
        marketValueConfirmed: 'Market value confirmed',
        marketValueNotConfirmed: 'Market value not confirmed',
        minimum: 'Minimum',
        average: 'Average',
        maximum: 'Maximum',
        total: 'Total',
        change: 'Difference',
        percentagePoints: 'pp',
        vacancy: 'Vacancy',
        previousValuation: 'Previous valuation',
        multiplier: 'Multiplier',
        options: 'Options',
        other: 'Other',
        energyEfficiencyClass: 'Energy efficiency class',
        heatingType: 'Heating type',
        fuelTypes: {
            wood: 'Wood',
            gas: 'Gas',
            oil: 'Oil',
            environmental_soil: 'Ambient heat (ground)',
            environmental_air: 'Ambient heat (air)',
            environmental_solar: 'Ambient heat (solar thermal)',
            electric_power: 'Electricity',
            erdgas: 'Natural gas',
            fluessiggas: 'LPG',
            heizoel_el: 'Heating oil',
            strom: 'Electricity',
            nah_fernwaerme: 'Local/district heating',
            holzpellets: 'Wood pellets',
            holzhackschnitzel: 'Wood chips',
            stueckholz: 'Firewood',
            waermepumpe: 'Heat pump',
            solarthermie: 'Solar thermal',
            geothermie: 'Geothermal',
            umweltwaerme: 'Ambient heat',
            hybrid_system: 'Hybrid system',
            biogas_biomethan: 'Biogas',
            steinkohle: 'Hard coal',
            braunkohle: 'Lignite',
        },
        primaryPowerConsumption: 'Primary energy consumption',
        kilowattHoursPerSquareMeterPerYear: 'kWh/m²/year',
        carbonDioxideEquivalent: 'CO₂ equivalent',
        unitLabels: {
            primaryPowerConsumption: 'kWh/(m²a)',
            carbonDioxideEquivalent: 'kg',
        },
        aiDataPrivacyInfo: {
            tooltip: 'Your data is processed within the EU and is not used to train AI models. Click for more information.',
            label: 'Privacy compliant',
            modalTitle: 'Data privacy',
            closeButtonLabel: 'Close',
            items: {
                confidentialData: 'We process your data confidentially and do not share it with third parties.',
                storageDuration: 'Uploaded files are retained temporarily for AI processing and deleted within one day.',
                euProcessing: 'einwert uses European servers only. Your data never leaves the EU.',
                noModelTraining: 'Your data is not used to train AI models.',
                supportPrefix: 'If you have any questions, feel free to write to us at',
                supportLinkLabel: 'support@einwert.com',
            },
        },
        notEnoughDataAvailableYet: 'There is not enough data available yet',
        marketValueResults: 'Market value results',
        incomeMetrics: 'Income metrics',
        residualUsefulLife: 'Residual lifespan',
        sensitivityMatrix: 'Sensitivity matrix',
        valuationKeyFigures: 'Valuation key figures',
        valXmlDownloadModal: {
            single: {
                title: 'Generate ValXML',
                headline: 'Generate ValXML from appraisal data',
                paragraphOne: 'ValXML is generated from the available appraisal data.',
                notEqual: 'This is not the ValXML that may have been provided by the appraiser in addition to the appraisal.',
            },
            multiple: {
                title: 'Generate ValXMLs',
                headline: 'Generate ValXMLs from appraisal data',
                paragraphOne: 'ValXMLs are generated from the available appraisal data.',
                notEqual: 'These are not the ValXMLs that may have been provided by the appraiser in addition to the appraisals.',
            },
            download: 'Download',
            cancel: 'Cancel',
            notAllConvertible: 'Not all appraisals can be converted to ValXML because not all required data is available.',
            draftWarning:
                'This ValXML is generated from a draft. The included values are not finalized yet and may differ from the final appraisal.',
        },
        orderStatuses: {
            open: {
                label: 'Order received',
                longLabel: 'Your order will be processed shortly',
            },
            accepted: {
                label: 'Order accepted',
                longLabel: 'The order has been accepted',
            },
            in_communication_with_owner: {
                label: 'In communication with owner',
                longLabel: 'We are communicating with the owner of the asset.',
            },
            inspection_scheduled: {
                label: 'Inspection scheduled',
                longLabel: 'An inspection date has been scheduled.',
            },
            in_progress: {
                label: 'In progress',
                longLabel: 'The appraisal is in progress',
            },
            in_review: {
                label: 'Draft review',
                longLabel: 'A new appraisal draft is ready for review',
            },
            done: {
                label: 'Completed',
                longLabel: 'Order completed',
            },
            blocked: {
                label: 'Blocked',
                longLabel: 'Order blocked',
            },
            on_hold: {
                label: 'On hold',
                longLabel: 'Order on hold',
            },
            temp_hide_in_portal: {
                label: 'Hidden',
                longLabel: 'Order is shown internally only',
            },
            canceled: {
                label: 'Cancelled',
                longLabel: 'Order cancelled',
            },
        },
        valuationReasons: {
            transaction: 'Transaction',
            recurring_valuation: 'Recurring appraisal',
            division_of_wealth: 'Division of assets',
            statement_of_assets: 'Statement of assets',
            financing_purposes: 'Financing purposes',
            court_proceedings: 'Court proceedings',
            purchase: 'Purchase',
            sale: 'Sale',
            tax_purposes: 'Tax purposes',
            partial_sale: 'Partial sale',
            accounting_purposes: 'Accounting',
            intrinsic_value_check: 'Intrinsic value check',
            auction: 'Auction',
            lending_purposes: 'Lending purposes',
        },
        valuationReasonGroups: {
            recurringValuation: 'Recurring appraisal',
            legalReasons: 'Legal background',
            accounting: 'Accounting',
            transactions: 'Transaction',
        },
        assetStates: {
            in_planning: 'In planning',
            under_construction: 'Under construction',
            existing: 'Existing',
            time_of_projection: 'Projected current value',
            after_finalization: 'After completion',
        },
        usageTypes: {
            residential: 'Residential',
            office: 'Office',
            retail: 'Retail',
            mixed: 'Mixed-use asset',
            garage: 'Parking',
            other: 'Other',
            unknown: 'Unknown',
            single_family_house: 'Single-family house',
            apartment: 'Condominium',
            two_family_house: 'Two-family house',
            semi_detached_house: 'Semi-detached house',
            townhouse_middle: 'Mid-terrace house',
            townhouse_end: 'End-terrace house',
            apartment_building: 'Apartment building',
            mixed_use_apartment_building: 'Residential building with mixed use',
            commercial_structure: 'Residential and commercial building',
            consumer_market: 'Consumer market',
            department_store: 'Department store',
            car_dealer: 'Car dealership',
            office_structure: 'Office',
            single_car_garage: 'Single-car garage',
            multi_car_garage: 'Multi-car garage',
            multi_story_parking_garage: 'Multi-storey parking garage',
            underground_parking_garage: 'Underground parking garage',
            commercial_vehicle_garage: 'Commercial vehicle garage',
            infrastructure: 'Infrastructure',
            logistics: 'Logistics',
            hotel: 'Hotel',
            industrial_structure: 'Industrial',
            nursing: 'Nursing',
            healthcare: 'Healthcare',
            specialty: 'Special purpose property',
            daycare: 'Daycare',
            hostel: 'Boarding house',
            senior_citizen_housing: 'Senior housing',
            micro_apartment: 'Micro apartment',
            shopping_center: 'Shopping center',
            logistics_hub: 'Logistics hub',
            data_center: 'Data center',
        },
        form: {
            salutation: 'Salutation',
            firstName: 'First name',
            lastName: 'Last name',
            jobTitle: 'Role',
            phoneNumber: 'Phone number',
            locale: 'Language',
            team: 'Team',
            email: 'Email address',
            certification: 'Certification',
        },
        salutations: {
            none: 'No salutation',
            mr: 'Mr.',
            ms: 'Ms.',
            mrDr: 'Mr. Dr.',
            msDr: 'Ms. Dr.',
        },
        userLink: {
            me: 'Me',
            external: 'External',
            unknown: 'Not set',
            unavailable: 'User unavailable',
            contact: 'Contact',
            editOwnContactTooltip: 'Edit own contact details',
            emailCopied: 'Email address copied',
            phoneCopied: 'Phone number copied',
            addressCopied: 'Address copied',
            note: 'Note',
            externalEmailInfo: 'This contact collaborates by email.',
        },
        confirmation: {
            discardAllUnsavedChanges: 'Discard all unsaved changes?',
            discard: 'Discard',
            cancel: 'Cancel',
        },
        actions: {
            upload: 'Upload',
            invite: 'Invite',
            startImport: 'Start import',
            apply: 'Apply',
            discard: 'Discard',
            save: 'Save',
            cancel: 'Cancel',
            remove: 'Remove',
            copy: 'Copy',
            export: 'Export',
            approve: 'Approve',
            close: 'Close',
            newOrder: 'New order',
            viewAsset: 'To asset',
            viewOrder: 'To order',
            viewValuation: 'To valuation',
            viewPlausibility: 'To plausibility check',
            expand: 'Expand',
            collapse: 'Collapse',
        },
        copiedToClipboard: '{{label}} copied to clipboard',
        shortcuts: {
            mac: 'Cmd + S',
            windows: 'Ctrl + S',
        },
        structureUsageTypes: {
            residential: 'Residential',
            office: 'Office',
            retail: 'Retail',
            mixed: 'Mixed-use property',
            garage: 'Parking',
            other: 'Other',
        },
        tenantUsageTypes: {
            residential: 'Residential',
            commercial: 'Commercial',
            gastronomy: 'Gastronomy',
            industry: 'Industry, production',
            hotel: 'Accommodation',
            storage: 'Storage',
            underground_parking: 'Underground parking space',
            leisure: 'Leisure',
            social: 'Social use',
            archive: 'Basement, archive',
            outdoor_parking: 'Outdoor parking space',
            parking: 'Parking',
            retail: 'Retail',
            logistics: 'Logistics',
            office: 'Office',
            other: 'Other',
            total: 'Total',
            other_parking: 'Other parking space',
            open_space: 'Open space',
            other_use: 'Other use',
            garage_parking: 'Garage parking space',
        },
        tenantRentalStatuses: {
            rented: 'Rented',
            unrented: 'Vacant',
            self_used: 'Owner-occupied',
        },
        tenantBreakdownTable: {
            headers: {
                areaAndUnits: 'Area and units',
                vacancy: 'Vacancy',
                delta: 'Delta',
            },
            empty: 'No entries available',
            units: {
                unit_one: 'unit(s)',
                unit_other: 'units(s)',
                parkingSpace_one: 'unit(s)',
                parkingSpace_other: 'unit(s)',
            },
            monetaryUnits: {
                perYear: '/year',
                perSquareMeterPerMonth: '/m² p.m.',
                perUnitPerMonth: '/unit p.m.',
                perParkingSpacePerMonth: '/unit p.m.',
            },
        },
        deviationAnalysisWidget: {
            headers: {
                current: 'Current',
                change: 'Difference',
                previousValuation: 'Previous valuation',
                previousValuationWithYear: 'Previous valuation ({{year}})',
            },
            sections: {
                marketValueResults: 'Market value results',
                keyEarningsFigures: 'Earnings figures',
                costs: 'Costs',
                yieldFigures: 'Yield',
                valuationRelevantAreas: 'Areas',
                valuationStructureLifeSpans: 'Residual lifespan',
            },
            units: {
                year: 'year',
                years: 'years',
            },
            selectOptions: {
                lockedDraftTitle: 'This draft',
                lockedValuationTitle: 'This valuation',
                draftStatus: 'Draft',
                finalStatus: 'Final',
            },
        },
        valuationMethods: {
            land_value: 'Land value',
            income: 'Income approach',
            investment_method: 'Investment method',
            comparison: 'Comparative value',
            cost: 'Cost value',
            discounted_cashflow: 'Discounted cash flow',
            custom: 'Unknown',
            leasehold: 'Leasehold',
        },
    },
    plausibility: {
        approveDraft: 'Approve draft',
        approvalImageAlt: 'approve',
        shareAnnotations: 'Share comments',
        makeAnnotationsVisible: 'Make all comments on this draft visible to the appraiser',
        draftApproved: 'Draft approved',
        approvedBy: 'Approved by',
        noAnnotations: 'No comments available',
    },
    marketData: {
        ratings: {
            noRating: 'No rating',
            veryGood: 'Very good',
            good: 'Good',
            average: 'Average',
            mediocre: 'Fair',
            bad: 'Poor',
            excellent: 'Excellent',
            aboveAverage: 'Above average',
            slightlyAboveAverage: 'Slightly above average',
            belowAverage: 'Below average',
            slightlyBelowAverage: 'Slightly below average',
            catastrophic: 'Catastrophic',
            veryAboveAverage: 'Well above average',
            veryBelowAverage: 'Well below average',
            unableToRate: 'Available data does not allow classification',
        },
    },
    export: {
        sectionTitle: 'Export',
        downloadExcelButtonLabel: 'Download Excel',
        valxmlUnavailableTooltip: 'The valuation is not compatible with the ValXML standard or does not contain all required data.',
        missingData: {
            featureLabel: 'Completeness check',
            fileNamePrefix: 'Valuation-Completeness-Check',
            modalPrimaryActionLabel: 'Export',
            modalDescription:
                'Here you can export the completeness check as an Excel file. Each asset is structured in its own worksheet in the Excel file.',
            modalDownloadInfo:
                'Creating the completeness check can take a few minutes. The export file will be downloaded automatically once it is ready.',
            sectionTitleStructures: 'Structures',
            sectionTitleValuations: 'Valuations',
            emptyStateNoAsset: 'No asset',
            emptyStateNoStructures: 'No structures',
            emptyStateNoValuations: 'No valuations',
            legendTitle: 'Legend',
            legendMeaningAvailable: 'Available',
            legendMeaningMissing: 'Missing',
            legendMeaningMissingOptional: 'Missing (but optional)',
            assetColumnCustomerAssetReference: 'Customer asset reference',
            assetColumnStreet: 'Street',
            assetColumnHouseNumber: 'House number',
            assetColumnZipCode: 'ZIP code',
            assetColumnCity: 'City',
            assetColumnRegion: 'Region',
            assetColumnCountry: 'Country',
            assetColumnCoordinates: 'Coordinates',
            assetColumnTitleImage: 'Title image',
            structureColumnTitle: 'Title',
            structureColumnUsageType: 'Usage type',
            structureColumnConstructionYear: 'Construction year',
            structureColumnEnergyEfficiencyClass: 'Energy efficiency class',
            structureColumnPrimaryPowerConsumption: 'Primary energy consumption',
            structureColumnHeatingEnergySource: 'Heating type',
            structureColumnHotWaterEnergySource: 'Hot water type',
            structureColumnUsageArea: 'Net floor area / usable area',
            valuationColumnTitle: 'Valuation title',
            valuationColumnValuationDate: 'Valuation date',
            valuationColumnAppraiser: 'Appraiser',
            valuationColumnAppraisingEntityName: 'Appraisal entity',
            valuationColumnPdf: 'PDF',
            valuationColumnMarketData: 'Market data',
            valuationColumnQualityAssessmentDate: 'Quality assessment date',
            valuationColumnReportDate: 'Completion date',
            valuationColumnInspectionDate: 'Inspection date',
            valuationColumnInspector: 'Inspector',
            valuationColumnSensitivityMatrix: 'Sensitivity matrix',
            valuationColumnTransactionCosts: 'Transaction costs',
            valuationColumnLandArea: 'Land area',
            valuationColumnGrossFloorArea: 'Gross floor area',
            valuationColumnUsageArea: 'Usable area',
            valuationColumnLivingArea: 'Living area',
            valuationColumnLandValue: 'Land value',
            valuationColumnIncomeMarketValue: 'Income approach value',
            valuationColumnCostMarketValue: 'Cost value',
            valuationColumnComparisonMarketValue: 'Comparative value',
            valuationColumnDiscountedCashflow: 'DCF',
            valuationColumnGrossYieldMultiplier: 'Gross yield multiplier',
            valuationColumnNetYieldMultiplier: 'Net yield multiplier',
            valuationColumnTenantIncomeBreakdown: 'Income (by type)',
            valuationColumnYearlyGrossRentalIncome: 'Annual gross rental income',
            valuationColumnYearlyNetRentalIncome: 'Annual net rental income',
            valuationColumnMaintenanceCosts: 'Maintenance costs',
            valuationColumnAdministrativeCosts: 'Administrative costs',
            valuationColumnOperatingCosts: 'Operating costs',
            valuationColumnLossOfRentRiskCosts: 'Loss-of-rent risk costs',
            valuationColumnManagementCosts: 'Management costs',
        },
        allValues: {
            downloadTooltip: 'Download valuation key figures',
            fileNamePrefix: 'Valuation-Key-Figures',
            worksheetName: 'Valuation key figures',
            values: {
                waultUnlimited: 'Unlimited',
            },
            rows: {
                valuationDate: 'Valuation date',
                discountedCashflowShort: 'DCF',
                transactionCosts: 'Transaction costs',
                marketValueIncludingTransactionCosts: 'Market value incl. transaction costs',
                mortgageLendingValue: 'Mortgage lending value',
                mortgageLendingValueWithMethod: 'Mortgage lending value {{method}}',
                grossRentalIncome: 'Gross rental income',
                managementCosts: 'Management costs',
                netRentalIncome: 'Net rental income',
                grossYieldMultiplier: 'Gross yield multiplier',
                netYieldMultiplier: 'Net yield multiplier',
                grossYieldVerbose: 'Yield (gross yield)',
                discountRate: 'Discount rate',
                grossFloorArea: 'Gross floor area',
                landArea: 'Land area',
                residualUsefulLifeWithStructure: 'Residual lifespan ({{structureTitle}})',
                reportLink: 'Report link',
            },
        },
        deviationAnalysis: {
            deviationAnalysisTitle: 'Deviation analysis',
            deviationAnalysisActionButtonLabel: 'Export',
            deviationAnalysisDownloadTooltip: 'Download deviation analysis',
            deviationAnalysisFileNamePrefix: 'Deviation-Analysis',
            deviationAnalysisWorksheetName: 'Deviation analysis',
            deviationAnalysisAssetLabel: 'Asset',
            deviationAnalysisValueColumnLabel: 'Value',
            deviationAnalysisChangeColumnLabel: 'Difference',
            deviationAnalysisChangePercentageColumnLabel: 'Difference %',
            deviationAnalysisRemainingUsefulLifePrefix: 'Residual lifespan',
            deviationAnalysisRowMortgageLendingValue: 'Mortgage lending value',
            deviationAnalysisRowTransactionCosts: 'Transaction costs',
            deviationAnalysisRowTotalSpecialPropertyFeatures: 'Special property features',
            deviationAnalysisRowGrossRentalIncome: 'Gross rental income (market rent)',
            deviationAnalysisRowContractualRentalIncome: 'Annual rent (contract rent)',
            deviationAnalysisRowManagementCosts: 'Management costs',
            deviationAnalysisRowMaintenanceCost: 'Maintenance costs',
            deviationAnalysisRowAdministrativeCost: 'Administrative costs',
            deviationAnalysisRowOperatingCost: 'Non-allocable operating costs',
            deviationAnalysisRowLossOfRentRiskCost: 'Loss-of-rent risk',
            deviationAnalysisRowNetRentalIncome: 'Net rental income',
            deviationAnalysisRowNetIncomeConstruction: 'Net income of the structure',
            deviationAnalysisRowValueConstruction: 'Income approach value of the structure',
            deviationAnalysisRowGrossYieldMultiplier: 'Gross yield multiplier',
            deviationAnalysisRowNetYieldMultiplier: 'Net yield multiplier',
            deviationAnalysisRowGrossYield: 'Yield (gross yield)',
            deviationAnalysisRowGrossFloorArea: 'Gross floor area',
        },
    },
}
